import { FC } from "react";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";

import { HomePage } from "@/pages/home";
import { BaseLayout } from "@/layouts/default";
import { ThanksPage } from "@/pages/thanks";
import { DeliveryPage } from "@/pages/delivery";
import { DeliverySearchPage } from "@/pages/delivery/search";
import { DeliveryProfilePage } from "@/pages/delivery/profile";
import { ThanksBRPage } from "@/pages/thanksBR";
import { DeliveryRefundPage } from "@/pages/delivery/refund";

export const AppRoutes: FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BaseLayout />}>
          <Route index element={<Navigate to="/1" replace={false} />} />
          <Route path="/1" element={<HomePage />} />
        </Route>
        <Route path="/thanks-es" element={<ThanksPage />} />
        <Route path="/thanks-br" element={<ThanksBRPage />} />
        <Route path="/delivery" element={<DeliveryPage />} />
        <Route path="/delivery.html" element={<DeliveryPage />} />
        <Route path="/delivery/search" element={<DeliverySearchPage />} />
        <Route path="/delivery/profile" element={<DeliveryProfilePage />} />
        <Route path="/delivery/refund" element={<DeliveryRefundPage />} />
      </Routes>
    </BrowserRouter>
  );
};
